import React from "react";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/lib/lang";

/**
 * Final CTA banner at the bottom of the landing.
 */
export default function FinalCTA({ onBook }) {
  const { t } = useLang();
  return (
    <section className="dt-finalcta" data-testid="final-cta">
      <div className="dt-finalcta__inner">
        <h2 className="dt-finalcta__title">{t("landing_cta_title")}</h2>
        <p className="dt-finalcta__desc">{t("landing_cta_desc")}</p>
        <div className="dt-finalcta__ctas">
          <button
            type="button"
            className="dt-btn dt-btn--primary"
            onClick={() => onBook("executive")}
            data-testid="final-cta-book"
          >
            {t("landing_cta_book")} <ArrowRight size={16} />
          </button>
          <a href="mailto:reservas@ditours.pt" className="dt-btn dt-btn--ghost" data-testid="final-cta-contact">
            {t("landing_cta_contact")}
          </a>
        </div>
      </div>
    </section>
  );
}
